import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Channel } from '../../../../models/channel.model';
import * as channelActions from '../../../../state/actions/channel.actions';
import { AppState } from '../../../../state/appstate';

@Component({
  selector: 'app-view-channel',
  standalone: true,
  imports: [CommonModule, RouterModule, RouterLink, RouterLinkActive],
  templateUrl: './view-channel.component.html',
})
export class ViewChannelComponent implements OnDestroy {
  channel$: Subscription | undefined;
  channel: Channel | null = null;

  ngOnDestroy(): void {
    this.channel$?.unsubscribe();
  }

  constructor(private store: Store<AppState>) {
    this.channel$ = this.store
      .select((state) => state.channel.channel)
      .subscribe((channel) => {
        this.channel = channel;
      });
  }

  refreshChannel() {
    try {
      this.store.dispatch(channelActions.loadChannel());
    } catch (error) {
      console.error(`Error: ${error}`);
    }
  }
}
